/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OnboardingProgressDto } from './OnboardingProgressDto';
import type { PendingActionDto } from './PendingActionDto';
export type GetMeDataDto = {
    id: string;
    full_name: string;
    phone_number?: Record<string, any> | null;
    phone_country_code?: Record<string, any> | null;
    email?: Record<string, any> | null;
    role: GetMeDataDto.role;
    gender?: Record<string, any> | null;
    date_of_birth?: Record<string, any> | null;
    auth_provider: string;
    is_google_linked: boolean;
    is_apple_linked: boolean;
    status: GetMeDataDto.status;
    /**
     * When the account was suspended
     */
    suspended_at?: Record<string, any> | null;
    /**
     * When the suspension ends (null = indefinite)
     */
    suspended_until?: Record<string, any> | null;
    /**
     * Reason for suspension
     */
    suspension_reason?: Record<string, any> | null;
    is_verified: boolean;
    profile_image_url?: Record<string, any> | null;
    onboarding_completed: boolean;
    onboarding_progress: OnboardingProgressDto;
    pending_actions: Array<PendingActionDto>;
    created_at?: string;
};
export namespace GetMeDataDto {
    export enum role {
        CLIENT = 'client',
        EXPERT = 'expert',
        UNASSIGNED = 'unassigned',
    }
    export enum status {
        ACTIVE = 'active',
        SUSPENDED = 'suspended',
        DELETED = 'deleted',
    }
}

